// Bus de eventos global para cambios en tareas (completar, descartar, reactivar, eliminar).
// Cualquier componente que muestra una lista de tareas puede suscribirse para
// mantenerse sincronizado sin necesidad de pasar callbacks entre componentes
// que no son padre/hijo directo (ej: drawer de Expediente -> Espacio de trabajo).
const target = new EventTarget();
const EVENT = 'tarea-changed';

// detail: { id, completada?, descartada?, eliminado? }
export function emitTareaChanged(detail) {
  target.dispatchEvent(new CustomEvent(EVENT, { detail }));
}

// handler recibe el detail. Devuelve función para desuscribirse.
export function onTareaChanged(handler) {
  const listener = (e) => handler(e.detail);
  target.addEventListener(EVENT, listener);
  return () => target.removeEventListener(EVENT, listener);
}
